import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Image} from 'antd';
import {Document, Page, pdfjs} from 'react-pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import {
  FilePreview
} from './StyledInvoiceAttachmentPreview';
import {fileHelpers} from '../../../../utils/helpers';

if (Boolean(!pdfjs.GlobalWorkerOptions.workerSrc)) pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;


const InvoiceAttachmentPreview = ({
  attachment,
  multiple = false,
  ...rest
}) => {
  const [pages, setPages] = useState(1);

  const isPdf = fileHelpers.hasExtensions(attachment?.name, ['.pdf']);

  const file = attachment?.file || undefined;

  const onLoadSuccess = ({numPages}) => {
    if (!multiple) return;
    if (pages !== numPages) setPages(numPages);
  }

  return (
    <FilePreview {...rest}>
      {isPdf ? (
        <Document
          file={file}
          onLoadSuccess={onLoadSuccess}
        >
          {[...Array(pages)].map((_, index) => (
            <Page
              key={index}
              pageNumber={index + 1}
              renderAnnotationLayer={false}
              renderTextLayer={false}
            />
          ))}
        </Document>
      ) : (
        <Image
          preview={false}
          src={file}
        />
      )}
    </FilePreview>
  );
}

InvoiceAttachmentPreview.propTypes = {
  attachment: PropTypes.shape({
    file: PropTypes.string,
    name: PropTypes.string
  }),
  multiple: PropTypes.bool
}

export default InvoiceAttachmentPreview;
